import React from 'react';
import './BlogContent.css';
import { Link } from 'react-router-dom';

const blogData = [
    {
        id: 1,
        title: "Marvel at New Parliament House",
        description: "“Marvel” Got the opportunity to install their Window Coverings products to the New Parliament House [...]",
        image: "/Assets/BlogImages/Image1.jpg",
        date: "30 May 2023",
        link: "/blog/marvel-at-new-parliament-house",
    },
];

const BlogContent = () => {
    return (
        <div className="Blog-pg-container">
            <div className="blog-page">
                <div className="blog-header">
                    <h1>Blog</h1>
                    <p>
                        Welcome to our blog, full of our ideas and passions. We care about creating beautiful window coverings as you care about creating an elegant home.
                    </p>
                </div>

                {Array.from({ length: Math.ceil(blogData.length / 2) }, (_, rowIndex) => {
                    const left = blogData[rowIndex * 2];
                    const right = blogData[rowIndex * 2 + 1];
                    const isEven = rowIndex % 2 === 0;

                    return (
                        <div key={rowIndex} className="blog-row">
                            {left && (
                                <div className={`blog-card ${isEven ? 'wide' : 'narrow'} card-left`}>
                                    <img src={left.image} alt={left.title} />
                                    {isEven ? (
                                        <div className="card-content-wrapper">
                                            <h2>{left.title}</h2>
                                            <p>{left.description}</p>
                                            {left.link !== null && (<Link to={left.link} className="read-more-btn">Read More</Link>)}
                                            <span className="date">{left.date}</span>
                                        </div>
                                    ) : (
                                        <>
                                            <h2>{left.title}</h2>
                                            <p>{left.description}</p>
                                            {left.link !== null && (<Link to={left.link} className="read-more-btn">Read More</Link>)}
                                            <span className="date">{left.date}</span>
                                        </>
                                    )}
                                </div>
                            )}

                            {right && (
                                <div className={`blog-card ${isEven ? 'narrow' : 'wide'} card-right`}>
                                    <img src={right.image} alt={right.title} />
                                    {!isEven ? (
                                        <div className="card-content-wrapper">
                                            <h2>{right.title}</h2>
                                            <p>{right.description}</p>
                                            {right.link !== null && (<Link to={right.link} className="read-more-btn">Read More</Link>)}
                                            <span className="date">{right.date}</span>
                                        </div>
                                    ) : (
                                        <>
                                            <h2>{right.title}</h2>
                                            <p>{right.description}</p>
                                            {right.link !== null && (<Link to={right.link} className="read-more-btn">Read More</Link>)}
                                            <span className="date">{right.date}</span>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}

            </div>
        </div>
    );
};

export default BlogContent;
